import React from 'react'
import { ARTICLE_FEATURED_TYPES } from '../../constants'
import ArticleOverlay from '../utils/ArticleOverlay'
import Link from '../utils/Link'
import { type ListBoxProps } from './Types'
import { getVideoLabel } from '../utils/VideoLabel'

export default (props: ListBoxProps) => {
  const {
    className,
    featuredSize,
    featuredType,
    link,
    onMouseOver,
    onMouseOut,
    title,
    duration,
    showLabel = false
  } = props

  const isFeatured = ARTICLE_FEATURED_TYPES.COMMON.includes(featuredType)

  return (
    <li className={className} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
      <Link href={link}>
        <span className={`title${isFeatured ? ' label' : ''}`}>
          { title }
        </span>
        {
          showLabel && isFeatured && <ArticleOverlay className={`${featuredSize} ${featuredType}`}>
            {
              getVideoLabel(featuredType, duration)
            }
          </ArticleOverlay>
        }
      </Link>
    </li>
  )
}
